import React from 'react'

interface PillProps {
  height: number
  width: number
  value?: number | string | undefined
  customCSS?: React.CSSProperties
}

const Pill: React.FC<PillProps> = ({ height, width, value = null, customCSS = {} }) => {
  const pillHeight = `${height * 16}px`
  const pillWidth = `${width * 16}px`

  return (
    <div
      style={{
        background: '#f0f0f0',
        borderRadius: '8px',
        height: pillHeight,
        width: pillWidth,
        ...(value && {
          paddingTop: '2px',
          textAlign: 'center',
          justifyContent: 'center'
        }),
        ...customCSS
      }}
    >
      {value && value}{' '}
    </div>
  )
}

export default Pill
